export enum FilterTypeEnum {
  WATCHLIST = 'WATCHLIST',
  STATUSES = 'STATUSES',
}
